<template>
  <div id="app">
    <vue-element-loading :active="validatignToken" is-full-screen/>
    <main v-if="this.user">
      <!-- <Menu :open="open"  @fecharMenu="open = !open"/>
      <MenuToggle  @abrirMenu="open = !open"/> -->
      <Header/>
      <HeaderBottom/>
      <!-- <Brands/> -->
      <Filters/>
      <Content/>
      <Footer/>
    </main>
    <Login v-if="!this.user"/>
  </div>
</template>

<script>
import axios from "axios"
import { baseApiUrl, userKey } from "@/global"
import { mapState } from "vuex"
import Header from '@/components/header/header.vue';
import HeaderBottom from '@/components/header/headerBottom.vue';
import Content from '@/components/content/content.vue';
// import Brands from '@/components/brands/brands.vue';
// import Menu from "@/components/menu/menu.vue";
// import MenuToggle from "@/components/menu/menu-toggle.vue";
import Filters from '@/components/filters/filters.vue';
import Footer from '@/components/footer/footer.vue';
import Login from '@/views/login/login.vue';
import "normalize.css";
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'App',
  components:{ Header, Content, Footer, Login, VueElementLoading, Filters, HeaderBottom },
  computed: mapState(['user']),
  data(){
    return{
        validatignToken: true,
         open: false
      }
  },
  methods: {
    async validateToken() {
      this.validatignToken = true;

			const json = localStorage.getItem(userKey)
      const userData = JSON.parse(json)
      this.$store.commit('setUser', null);

			if(!userData) {
        this.validatignToken = false;
        this.$router.push({ name: 'login' })
        return
      }
      
        axios.defaults.headers.common['Authorization'] = `bearer ${userData.accessToken}`
        await axios.post(`${baseApiUrl}/login/validateToken`)
          .then(() =>{
              this.$store.commit('setUser', userData);
              this.$router.push({ name: 'home' })
              this.validatignToken = false;
          }).catch(() =>{
            localStorage.removeItem(userKey)
            this.$router.push({ name: 'login' })
            this.validatignToken = false;
          })
      }
    },  
    mounted(){
      this.validateToken();
    }
}
</script>


<style>
@import url('https://fonts.googleapis.com/css?family=Roboto:400,500&display=swap');

html{
  background-color: #EFEFEF;
  font-family: 'Roboto', sans-serif;
}

body{
  min-width: 320px
}

#app{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  justify-content: flex-end;
  /* max-width: 1920px; */
}

   main{
    width: calc(100%);
    margin-bottom: 55px;
  }

@media screen and (max-width: 900px) {
  main{
    width: 100%;
  }
}

button.badger-accordion-toggle {
    outline: none!important;
    border: none!important;
}
</style>
